import React from "react";
import cn from "classnames";

import { StyledLabel, Required } from "./styles";
import { IProps } from "./interfaces";

const Label = ({ children, disabled, required, center }: IProps) => (
    <StyledLabel className={cn(disabled && "Disabled", center && "Center")}>
        {children} {required && <Required>*</Required>}
    </StyledLabel>
);

export default Label;
